import { slugify } from './slugify'

const pad2 = (n: number): string => String(n).padStart(2, '0')

export type BuildFileNameArgs = {
  poiTitle: string
  poiIndex: number
  sectionIndex: number
  contentIndex: number
  partIndex: number
  partCount: number
  ext?: string
}

// File name = the structure that makes the later doyo import easy: it binds each
// recording unambiguously to its content block.
//
//   <poi-slug>_<POI##>_<Section##>_<Content##>[ _p## ].mp3
//   e.g. fuldaer-dom_01_01_01.mp3   (single text)
//        fuldaer-dom_01_01_03_p02.mp3  (2nd part of a multi-part block)
//
// Two deliberate conventions (see plan) — change here if doyo expects otherwise:
//  1. `contentIndex` runs within the SECTION (nuggets flattened) -> matches the
//     existing 3-group names like "01-01-01".
//  2. multi-part blocks (text_1, text_2, …) get a `_p##` suffix; single `text`
//     blocks get none.
export function buildVoiceoverFileName ({
  poiTitle,
  poiIndex,
  sectionIndex,
  contentIndex,
  partIndex,
  partCount,
  ext = 'aac'
}: BuildFileNameArgs): string {
  const base = `${slugify(poiTitle)}_${pad2(poiIndex)}_${pad2(sectionIndex)}_${pad2(contentIndex)}`
  const part = partCount > 1 ? `_p${pad2(partIndex)}` : ''
  return `${base}${part}.${ext}`
}
